"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_CLOSE_TIMEOUT = exports.uploadcareUrl = exports.isSFDC = exports.getParameterByName = exports.gravatarUrl = exports.getInitials = exports.isEllipsisActive = exports.resolveIconString = exports.generateUUID = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const crypto_js_1 = __importDefault(require("crypto-js"));
const endsWith_1 = __importDefault(require("lodash/endsWith"));
/* eslint-disable no-bitwise */
const generateUUID = (short) => {
    const mask = short ? 'xxxxxxxx-xxxx' : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return mask.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-mixed-operators
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
exports.generateUUID = generateUUID;
const resolveIconString = (icon, className = '') => {
    if ((0, endsWith_1.default)(icon, '.svg')) {
        return react_1.default.createElement("img", { src: icon, alt: "fab-icon", className: (0, classnames_1.default)(className, 'icon-as-image') });
    }
    return react_1.default.createElement("i", { className: (0, classnames_1.default)(className, 'fa', icon) });
};
exports.resolveIconString = resolveIconString;
const isEllipsisActive = (element) => (element.offsetWidth < element.scrollWidth);
exports.isEllipsisActive = isEllipsisActive;
const getInitials = (string) => {
    const names = string.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
};
exports.getInitials = getInitials;
const retinizeSize = (size) => Math.ceil(size * Math.max(window.devicePixelRatio || 1, 1));
const gravatarUrl = (email, size = 40) => {
    if (!email) {
        return '';
    }
    return `https://secure.gravatar.com/avatar/${crypto_js_1.default.MD5(email.trim().toLowerCase()).toString()}?s=${retinizeSize(size)}&d=mm&default=https://app.totango.com/img/transparent35px.png`;
};
exports.gravatarUrl = gravatarUrl;
const getParameterByName = (value, defaultValue = null) => {
    try {
        const name = value.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp(`[\\\\?&]${name}=([^&#]*)`);
        const results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    catch (err) {
        console.error('get parameter error: ', err);
        return defaultValue;
    }
};
exports.getParameterByName = getParameterByName;
exports.isSFDC = (0, exports.getParameterByName)('sfdc') === 'true';
const uploadcareUrl = (uuid, size) => {
    const resizeFunc = size ? `-/resize/${size}x/` : '';
    if (!uuid) {
        return '';
    }
    return `https://ucarecdn.com/${uuid}${(0, endsWith_1.default)(uuid, '/') ? '' : '/'}${resizeFunc}`;
};
exports.uploadcareUrl = uploadcareUrl;
exports.MODAL_CLOSE_TIMEOUT = 300;
//# sourceMappingURL=utils.js.map